import { debounce } from 'lodash';
import { execOnLoad } from '@general/helpers';
import './localization-selector.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initLocalizationSelector = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const searchInput = sectionContainer.querySelector(
    '.localization-selector__search input',
  );
  if (!searchInput) return;

  const listItems = sectionContainer.querySelectorAll(
    '.localization-selector__item[data-search-info]',
  );
  const searchElement = debounce(() => {
    listItems.forEach((item) => {
      if (!searchInput.value) {
        item.style.display = '';
        return;
      }

      const searchValue = searchInput.value.toLowerCase();
      const searchData = item.dataset.searchInfo.toLowerCase().split('|');
      const isValueInData = searchData.some(
        (data) => data.indexOf(searchValue) >= 0,
      );
      item.style.display = isValueInData ? '' : 'none';
    });
  }, 300);
  searchInput.addEventListener('input', searchElement);
};

execOnLoad(
  window.dAgency.initLocalizationSelector,
  '.localization-selector__section',
);
